//@ts-nocheck
import * as type from "../actions/actionTypes";

const initialState = {
  manufacturers: {
    fetching: false,
    error: null,
    data: [],
    paging: {
      pageStart: 0,
      pageLimit: 10,
      totalCount: 0,
      nextPageStart: "",
      previousPageStart: "",
    },
  },
  products: {
    fetching: false,
    error: null,
    data: [],
    paging: {
      pageStart: 0,
      pageLimit: 10,
      totalCount: 0,
      nextPageStart: "",
      previousPageStart: "",
    },
  },
  categories: {
    fetching: false,
    error: null,
    data: [],
    paging: {
      pageStart: 0,
      pageLimit: 10,
      totalCount: 0,
      nextPageStart: "",
      previousPageStart: "",
    },
  },
  manufacturer: {
    fetching: false,
    error: null,
    data: null,
  },
  product: {
    fetching: false,
    error: null,
    data: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.GET_CATALOGUE_MANUFACTURERS_REQUEST:
      return {
        ...state,
        manufacturers: {
          ...state.manufacturers,
          fetching: true,
          error: null,
          data: [],
        },
      };
    case type.GET_CATALOGUE_MANUFACTURERS_RECEIVE:
      return {
        ...state,
        manufacturers: {
          ...state.manufacturers,
          fetching: false,
          error: null,
          data: action.payload,
          paging: action.paging,
        },
      };
    case type.GET_CATALOGUE_MANUFACTURERS_FAILURE:
      return {
        ...state,
        manufacturers: {
          ...state.manufacturers,
          fetching: false,
          error: action.payload,
          data: [],
        },
      };
    case type.GET_CATALOGUE_PRODUCTS_REQUEST:
      return {
        ...state,
        products: {
          ...state.products,
          fetching: true,
          error: null,
          data: [],
        },
      };
    case type.GET_CATALOGUE_PRODUCTS_RECEIVE:
      return {
        ...state,
        products: {
          ...state.products,
          fetching: false,
          error: null,
          data: action.payload,
          paging: action.paging,
        },
      };
    case type.GET_CATALOGUE_PRODUCTS_FAILURE:
      return {
        ...state,
        products: {
          ...state.products,
          fetching: false,
          error: action.payload,
          data: [],
        },
      };
    case type.GET_MANUFACTURER_CATEGORIES_REQUEST:
      return {
        ...state,
        categories: {
          ...state.categories,
          fetching: true,
          error: null,
          data: [],
        },
      };
    case type.GET_MANUFACTURER_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          fetching: false,
          error: null,
          data: action.payload,
          paging: action.paging,
        },
      };
    case type.GET_MANUFACTURER_CATEGORIES_FAILURE:
      return {
        ...state,
        categories: {
          ...state.categories,
          fetching: false,
          error: action.payload,
          data: [],
        },
      };
    case type.GET_CATALOGUE_MANUFACTURER_REQUEST:
      return {
        ...state,
        manufacturer: {
          fetching: true,
          error: null,
          data: null,
        },
      };
    case type.GET_CATALOGUE_MANUFACTURER_RECEIVE:
      return {
        ...state,
        manufacturer: {
          fetching: false,
          error: null,
          data: action.payload,
        },
      };
    case type.GET_CATALOGUE_MANUFACTURER_FAILURE:
      return {
        ...state,
        manufacturer: {
          fetching: false,
          error: action.payload,
          data: null,
        },
      };
    case type.GET_CATALOGUE_PRODUCT_REQUEST:
      return {
        ...state,
        product: {
          fetching: true,
          error: null,
          data: null,
        },
      };
    case type.GET_CATALOGUE_PRODUCT_RECEIVE:
      return {
        ...state,
        product: {
          fetching: false,
          error: null,
          data: action.payload,
        },
      };
    case type.GET_CATALOGUE_PRODUCT_FAILURE:
      return {
        ...state,
        product: {
          fetching: false,
          error: action.payload,
          data: null,
        },
      };
    default:
      return state;
  }
};
